import Project from 'viewsOld/Project'

const ProjectDetailsPage = () => {
    return <Project />
}

export default ProjectDetailsPage
